import { useApi } from "./api-service";

export type AgentIdAndName = {
  id: string;
  name: string;
};

export function usePermissionsService() {
  const isAgentRequired = false;
  const permissionsApi = useApi(isAgentRequired);

  return {
    getMemberPermissions: async (userId: string): Promise<any> => {
      return permissionsApi.get<any>(`/users/${userId}/permissions`);
    },
    saveMemberPermissions: async (
      userId: string,
      agentIds: string[]
    ): Promise<AgentIdAndName> => {
      return permissionsApi.put<AgentIdAndName>(
        `/users/${userId}/permissions`,
        {
          agentIds,
        }
      );
    },
  };
}
